/**
 * Un codice del catalogo delle segnalazioni. E' del Motore, non di questo portale: la SPA lo mostra
 * tradotto e lo rimanda com'e'. Resta una stringa di proposito — un'unione di letterali qui sarebbe una
 * seconda copia del catalogo, e si scoprirebbe vecchia solo quando il Motore ne pubblica uno nuovo.
 */
export type ReportCategory = string;

/** Cosa si sta per mandare: la categoria scelta e la descrizione scritta. */
export interface ReportDraft {
  readonly category: ReportCategory;
  readonly text: string;
  /** Il messaggio a cui la segnalazione si riferisce, dove la si apre da uno. */
  readonly messageId?: string;
}

/**
 * Quanto puo' essere lunga la descrizione. E' la misura del BFF
 * (<c>SessionReport.MaxTextLength</c>): tenerla anche qui ferma il testo dove si scrive, invece di
 * farlo rifiutare dopo l'invio.
 */
export const REPORT_MAX_TEXT_LENGTH = 2000;

/** Il prefisso sotto cui il dizionario tiene l'etichetta di una categoria. */
export const REPORT_CATEGORY_TRANSLATION_PREFIX = 'reports.categories.';
